import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Membership } from '../models/membership'
import { Mapper } from './mapper.service'
import { Store } from './store'
import { ApiService, ApiResponse } from './api.service'

interface MembershipOptionParams {
  'persona_id[]': number[]
  membership_definition_id?: string
  boss_organization_id: number
  include_requested?: boolean,
  requested_by: string
}

interface MembershipOptions {
  params: MembershipOptionParams
}

@Injectable({
  providedIn: 'root'
})
export class PersonaMembershipService extends Store<Membership[]> {

  constructor(private api: ApiService) {
    super(null)
  }

  public findCurrent(personaIds: number[], bossOrganizationId: number, membershipDefinitionId?: string, includeRequested = false): void {
    this.getMembershipsForPersonas(personaIds, bossOrganizationId, membershipDefinitionId, includeRequested)
      .subscribe(
        (data: ApiResponse<Membership[]>) => {
          const memberships = Mapper.asArray<Membership>(data.result, Membership)
          this.subject.next(memberships)
        }
      )
  }

  public getMembershipsForPersonas(personaIds: number[],
                                   bossOrganizationId: number,
                                   membershipDefinitionId?: string,
                                   includeRequested = false): Observable<ApiResponse<Membership[]>> {
    const options: MembershipOptions = {
      params: {
        'persona_id[]': personaIds,
        boss_organization_id: bossOrganizationId,
        requested_by: 'membership_ui'
      }
    }
    if (membershipDefinitionId) options.params.membership_definition_id = membershipDefinitionId
    if (includeRequested) options.params.include_requested = true
    return this.getMemberships(options)
  }

  private getMemberships(options: MembershipOptions): Observable<ApiResponse<Membership[]>> {
    return this.api.get('memberships', options)
  }
}
